import {getRequestLanguage} from "../common/lang";

export function findLocalizedUrl(countryCode2: string, languageCode2: string): URL|null
{
    const needle = `${languageCode2}-${countryCode2}`.toLowerCase();

    const currentRequestLanguage = getRequestLanguage();
    if (currentRequestLanguage === needle) {
        return new URL(window.location.href);
    }

    const url = localizedUrls().get(needle);
    return url === undefined ? null : new URL(url);
}

let cachedLocalizedUrls: Map<string, URL>|null = null;
function localizedUrls(): Map<string, URL> {
    if (cachedLocalizedUrls !== null) {
        return cachedLocalizedUrls;
    }

    const languageUrls = (window as any).clxPageLanguageUrls as Record<string, string>|undefined;
    if (typeof languageUrls !== 'object') {
        throw new Error('Missing localized URLs. Expected global property clxPageLanguageUrls on window.');
    }

    cachedLocalizedUrls = new Map<string, URL>(
        Object.entries(languageUrls)
            .map(([lang, url]) => [lang, new URL(url)])
    );
    return cachedLocalizedUrls;
}
